import React from "react"; 
import ProjectForm from "../../components/forms/EditProject/ProjectForm"

const ProjectInformationView: React.FC = () => {
  return (
   <>
   <ProjectForm />
   </>
  );
};

export default ProjectInformationView;
